import type React from 'react';
import { useScreenSize } from '~/common/hooks/useScreenSize.ts';


export interface ResponsiveContainerProps {
  mobile: React.ReactNode;
  desktop: React.ReactNode;
}

export function ResponsiveContainer({mobile, desktop}: ResponsiveContainerProps) {

  const {isMobile} = useScreenSize();

  if(isMobile) {
    return mobile;
  }

  return desktop;
}